/** @jsxRuntime classic */
/** @jsx jsx */
import { LogError } from 'business/constants';
import ProjectLinkList from 'components/pages/work/project-link-list';
import PageLayout from 'components/ui-components/layout/PageLayout';
import SEO from 'components/utility-wrappers/seo';
import { Fragment, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import useSWR from 'swr';
import { Box, jsx } from 'theme-ui';
import { changeBgColor } from 'utils/helpers';
import ProjectListItem from './project-list-item';

const request = {
  params: {},
  query: `{
    'projects':*[_type == 'project' && !(_id in path("drafts.**"))]{
      title,
      _id,
      slug,
      'categories': categories[]->title,
      'imageUrl': mainImage.asset->url,
      list_grid[]{
        site_image{
          asset->{
            ...
          },
          ...,
        },
        ...
      }
    } | order(sort_order asc),
    'workpage':*[_type == 'workpage' && _id == 'workpage']{
      backgroundcolor,
      seo,
      slug,
      title
    }[0]
  }`,
};

export default function Work(props) {
  const { data, error } = useSWR([request.query.toString(), request.params]);
  const match = useRouteMatch();

  useEffect(() => {
    changeBgColor(data?.workpage?.backgroundcolor || props.color);
  }, [props.color, data]);

  if (error || !data) {
    error && LogError(request.query, request.params, error);
    return null;
  }

  const { projects, workpage = {} } = data || {};

  return (
    <Fragment>
      <SEO title={workpage.title} {...workpage?.seo} />
      <PageLayout>
        <Box
          data-scroll-section
          sx={{
            marginLeft: 'auto',
            marginY: [4, 5, 6],
            maxWidth: [null, `${(100 / 12) * 6}%`],
            marginRight: [0, `${100 / 12}vw`],
          }}
        >
          <ProjectLinkList projects={projects} />
        </Box>
        {projects.map((project, i) => {
          return (
            <ProjectListItem
              {...project}
              key={project._id || i}
              to={`${match.url}/${project.slug.current}`}
            />
          );
        })}
      </PageLayout>
    </Fragment>
  );
}
